import React from 'react';
import { Marker } from 'react-leaflet';
import { useDispatch } from 'react-redux';
import {
  closeDisplays,
} from '../../state/uiControl/uiControl.actions';
import selected from '../../assets/images/locator.svg';
import L from 'leaflet';
import { Entry } from '../../services/types';
import { longitudeOffsets } from '../LeafletMap';

const selectedIcon = new L.Icon({
  iconUrl: selected,
  iconSize: [65, 65],
  iconAnchor: [32, 57]
});

type SelectedMarkerProps = {
  selectedEntry: Entry & { lat: number; long: number };
}

const SelectedMarker: React.FC<SelectedMarkerProps> = ({ selectedEntry }) => {
  const dispatch = useDispatch();
  return (
    <div>
      {longitudeOffsets.map((longOffset, index) => (
        <Marker
          key={`selected ${index}`}
          entry={selectedEntry}
          position={[
            selectedEntry.lat,
            selectedEntry.long + longOffset
          ]}
          zIndexOffset={235}
          icon={selectedIcon}
          riseOnHover={true}
          onClick={() => dispatch(closeDisplays())}
        />
      ))}
    </div>
  );
};


export default SelectedMarker;